module.exports = __webpack_public_path__ + "static/media/10_l_bildbord_5.52_45.28.39d00bd7.png";